// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c81o8v{font:var(--ds-font-body-small,normal 400 11px/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._18m915vq{overflow-y:hidden}\n._1bto1l2s{text-overflow:ellipsis}\n._1reo15vq{overflow-x:hidden}\n._o5721q9c{white-space:nowrap}\n._syazazsu{color:var(--ds-text-subtle,#505258)}", ""]);
// Exports
module.exports = exports;
